import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { Routes, Route } from "react-router-dom";
import { observer } from "mobx-react-lite";

// Pages
import HospitalPage from "~/views/appointment/hospitals/HospitalPage";
import SpecialistPage from "~/views/appointment/specialist/SpecialistPage";
import SpecialityPage from "~/views/appointment/speciality/SpecialityPage";
import AppointmentTimePage from "~/views/appointment/time/AppointmentTimePage";
import JournalPage from "~/views/appointment/journal/JournalPage";
// Components
import UserAppointmentSteps from "~/components/UserAppointmentSteps/UserAppointmentSteps";
import UserInformation from "~/components/UserInformation/UserInformation";
// Styles
import s from "~/views/appointment/RootAppointmentPage.module.scss";
// Hooks
import { useStore } from "~/hooks/useStore";
import usePrevious from "~/hooks/usePrevious";
import ROUTES from "~/utils/routes";

interface Props {}
const RootAppointmentPage: React.FC<Props> = observer(({}) => {
  const { pathname } = useLocation();
  const store = useStore();
  const hospitalId = store.hospitalStore.currentHospital
    ? store.hospitalStore.currentHospital.idHospital
    : null;
  const previousStoreData = usePrevious({
    hospitalId,
  });

  const calculateSubroute = (route: string) => {
    return route.replace(ROUTES.APPOINTMENT.PATHNAME, "");
  };

  useEffect(() => {
    return () => {
      store.resetAppointmentProcess();
    };
  }, [store]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <>
      <div className="screen-container">
        <UserInformation />
      </div>

      {pathname !== ROUTES.JOURNAL.PATHNAME && (
        <div className={s.userSteps}>
          <div className="screen-container">
            <UserAppointmentSteps />
          </div>
        </div>
      )}

      <div>
        <Routes>
          <Route
            path={calculateSubroute(ROUTES.HOSPITALS.PATHNAME)}
            element={<HospitalPage />}
          />

          <Route
            path={calculateSubroute(ROUTES.SPECIALTIES.PATHNAME)}
            element={
              <SpecialityPage
                previousHospitalId={previousStoreData?.hospitalId}
                hospitalId={hospitalId}
              />
            }
          />

          <Route
            path={calculateSubroute(ROUTES.DOCTORS.PATHNAME)}
            element={<SpecialistPage />}
          />

          <Route
            path={calculateSubroute(ROUTES.DATES.PATHNAME)}
            element={<AppointmentTimePage />}
          />

          <Route
            path={calculateSubroute(ROUTES.JOURNAL.PATHNAME)}
            element={<JournalPage />}
          />
        </Routes>
      </div>
    </>
  );
});

export default RootAppointmentPage;
